import { type DOMKeyframesDefinition } from 'framer-motion';

import {
  type CardMiniGameType,
  type MiniGameDataType,
} from '@/common/types/dice-game';
import { type GoodsType } from '@/common/types/goods';
import { type PlantTypeText } from '@/common/types/plant';
import { type ResourceTypeText } from '@/common/types/resource';

interface ParseCellContentReturnType {
  kind: CardMiniGameType;
  props: {
    item?: ResourceTypeText | PlantTypeText | GoodsType | 'cash';
    value?: number;
  };
}

const parseCellContent = (cellContent: string): ParseCellContentReturnType => {
  const [kind, reward, value] = cellContent.split(':');

  const item =
    reward && value
      ? (reward as ResourceTypeText | PlantTypeText | GoodsType)
      : reward
        ? 'cash'
        : undefined;
  const rewardValue =
    reward && value ? Number(value) : reward ? Number(reward) : undefined;

  return {
    kind: kind as CardMiniGameType,
    props: {
      item,
      value: rewardValue,
    },
  };
};

const getActiveBoard = (
  miniGame?: MiniGameDataType,
): 'dice' | 'miniGame' | 'cards' | 'box' => {
  switch (miniGame?.type) {
    case 'tgem':
    case 'str': {
      return 'miniGame';
    }
    case 'Resource':
    case 'Material':
    case 'Product':
    case 'cash': {
      return 'cards';
    }
    default: {
      return 'dice';
    }
  }
};

const createActiveTileKeyframes = (
  currentPostion: number,
  count: number,
  tileAnimationSteps: null | number[][],
): DOMKeyframesDefinition => {
  const keyframesAnimation: DOMKeyframesDefinition = {
    x: [null],
    y: [null],
  };

  if (!tileAnimationSteps) {
    return keyframesAnimation;
  }
  for (let index = 1; index <= count; index++) {
    const animationIndex = (index + currentPostion) % 20;
    const animationPosition = tileAnimationSteps[animationIndex];

    if (Array.isArray(keyframesAnimation.x)) {
      keyframesAnimation.x.push(animationPosition[0]);
    }

    if (Array.isArray(keyframesAnimation.y)) {
      keyframesAnimation.y.push(animationPosition[1]);
    }
  }

  return keyframesAnimation;
};

export {
  createActiveTileKeyframes,
  getActiveBoard,
  parseCellContent,
  type ParseCellContentReturnType,
};
